import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";
import Navbar from "../home/components/Navbar";

export default function AlarmsPage() {
  const [alarms, setAlarms] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);

  const fetchAlarms = async () => {
    try {
      setLoading(true);
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) return;

      const { data: alarmsData, error: alarmsError } = await supabase
        .from("price_alerts")
        .select("*")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false });

      if (alarmsError) throw alarmsError;

      if (alarmsData && alarmsData.length > 0) {
        const productIds = alarmsData
          .map((a) => a.product_id)
          .filter((id) => id);
        const { data: productsData } = await supabase
          .from("products")
          .select("*")
          .in("id", productIds);

        const combined = alarmsData.map((alarm) => ({
          ...alarm,
          products: productsData?.find((p) => p.id === alarm.product_id),
        }));
        setAlarms(combined);
      } else {
        setAlarms([]);
      }
    } catch (err) {
      console.error("Hata:", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteAlarm = async (id: number) => {
    try {
      const { error } = await supabase
        .from("price_alerts")
        .delete()
        .eq("id", id);
      if (error) throw error;
      setAlarms((prev) => prev.filter((a) => a.id !== id));
      window.dispatchEvent(new Event("navbar-update"));
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } catch (err) {
      console.error("Silme hatası:", err);
    }
  };

  useEffect(() => {
    fetchAlarms();
    const handleRefresh = () => fetchAlarms();
    window.addEventListener("navbar-update", handleRefresh);
    return () => window.removeEventListener("navbar-update", handleRefresh);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 1. ÜST MENÜ FIX: 
          Navbar'ı isScrolled={false} yaparak beyaz yazı moduna alıyoruz. 
          Hemen arkasına koyu bir div ekleyerek Favoriler sayfasındaki görünümü sağlıyoruz. 
      */}
      <div className="fixed top-0 left-0 w-full h-[80px] bg-[#1a1c2c] z-[40]"></div>
      <Navbar isScrolled={false} />

      {/* SİLME BİLDİRİMİ */}
      {showToast && (
        <div className="fixed top-24 right-6 z-[9999] animate-in fade-in slide-in-from-right-10 duration-300">
          <div className="bg-gray-900 text-white px-5 py-3 rounded-2xl shadow-2xl flex items-center gap-3 border border-gray-700">
            <i className="ri-check-line text-emerald-500 font-bold"></i>
            <span className="text-sm font-bold text-white">
              Alarm kaldırıldı.
            </span>
          </div>
        </div>
      )}

      {/* 2. İÇERİK DÜZENİ: pt-32 ile içeriği Navbar'ın altından başlatıyoruz. */}
      <main className="max-w-7xl mx-auto px-4 pt-32 pb-12">
        <div className="flex justify-between items-center mb-10">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight uppercase italic">
            Fiyat Alarmlarım
          </h1>
          <span className="bg-rose-600 text-white px-4 py-1 rounded-full text-xs font-bold">
            {alarms.length} Ürün Takipte
          </span>
        </div>

        {loading ? (
          <div className="text-center py-20 text-gray-400 italic font-sans">
            Yükleniyor...
          </div>
        ) : alarms.length === 0 ? (
          <div className="text-center py-24 bg-white rounded-3xl border border-gray-100 shadow-sm">
            <p className="text-gray-500 font-medium font-sans">
              Henüz bir fiyat alarmı kurmadınız.
            </p>
          </div>
        ) : (
          <div className="grid gap-4">
            {alarms.map((alarm) => (
              <div
                key={alarm.id}
                className="bg-white p-4 rounded-2xl shadow-sm hover:shadow-md transition-all flex items-center gap-6 border border-gray-100 group"
              >
                <div className="w-20 h-20 bg-gray-50 rounded-xl p-2 flex-shrink-0">
                  <img
                    src={alarm.products?.image_url}
                    alt=""
                    className="w-full h-full object-contain mix-blend-multiply"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-800 line-clamp-1 text-lg mb-1">
                    {alarm.products?.title || alarm.products?.name}
                  </h3>
                  {/* SADECE FİYAT */}
                  <span className="text-rose-600 font-black px-3 py-1 bg-rose-50 rounded-lg text-sm">
                    {alarm.products?.price || alarm.products?.current_price} TL
                  </span>
                </div>
                <button
                  onClick={() => deleteAlarm(alarm.id)}
                  className="p-3 text-gray-300 hover:text-rose-600 hover:bg-rose-50 rounded-xl transition-all cursor-pointer"
                >
                  <i className="ri-delete-bin-line text-2xl"></i>
                </button>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
